export default __webpack_public_path__ + "db9bbd5a0b630b91dfe198d6aeccacf3.svg";